<template>
  <custom-dialog width="1280px" class="accounts-receivable-dialog" :visible="visible" :append-to-body="true" v-on="$listeners" :title="model.title">
    <div class="dialog-body">
      <div class="item-title">{{ $t('deposit_refund_select_dialog.yfyjxx') }}</div>
      <div class="table-bd">
        <custom-table :data="tableList" tableCode="portal_deposit_refund_select" type="checkbox" v-model="selectList" @filter="filterChange" @sort="sortChange"></custom-table>
      </div>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('deposit_refund_select_dialog.que_ren') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [dialogMixins],
  data() {
    return {
      tableList: [],
      selectList: [],
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    getReqData() {
      const data = this.model.data;
      return {
        existBillIds: data.existBillIds,
        payableOrgId: data.payableOrgId,
        receivableOrgId: data.receivableOrgId,
      };
    },
    getTableList() {
      const reqData = this.getReqData();
      this.$getJSON(apis.DepositRefundList, reqData).then((res) => {
        const list = res.data;
        this.tableList = list;
      });
    },
    closeDialog() {
      this.visible = false;
    },
    onCancel() {
      this.closeDialog();
    },
    onConfirm() {
      this.closeDialog();
      this.$emit('confirm', this.selectList);
    },
  },
};
</script>

<style></style>
